import { openModal } from './showModal'
import { pickElementById } from './utils'

export function openModalNativeButtons() {
  const oberserver = new MutationObserver(() => {
    const weCallYouBtn = pickElementById('cta_te_ayudamos_ringpool')

    if (weCallYouBtn !== null) {
      weCallYouBtn.removeAttribute('href')
      openModal(weCallYouBtn)
      oberserver.disconnect()
    }
  })

  oberserver.observe(document.body, { childList: true, subtree: true })
}
